<template>
  <CModal :title="title"
          color="info"
          :show="show"
          :centered="true"
          @update:show="$emit('update:show', false)">

    <div class="content">
      <div class="modal-title">
        <h2 class="">{{ title }}</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div v-if="errors.length" class="my-3">
        <CAlert v-for="(error, index) in errors" :key="`error-${index}`" color="danger" closeButton>
          {{ error }}
        </CAlert>
      </div>

      <CRow>
        <CCol col="12">
          <CForm @submit="handleAddAlias">
            <CInput v-model="fields.name.value" label="Name" description="Alias name" placeholder="Name" horizontal />
          </CForm>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="handleCancel" color="secondary">
        Cancel
      </CButton>
      <CButton @click="handleAddAlias" :disabled="!isDataValid" color="success">
        Add
      </CButton>
    </template>

  </CModal>
</template>

<script>
// import { mapActions } from 'vuex'
// import sortBy from 'lodash-es/sortBy'

export default {
  name: 'alias-add-modal',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    portId: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: 'Aliases',
    },
    addMethod: {
      type: Function,
      default: () => {
        console.log('add method is not specified')
      },
    },
  },

  data() {
    return {
      loading: false,
      errors: [],

      fields: {
        name: {
          value: null,
        },
      },
    };
  },

  async mounted() {
    // ...
  },

  methods: {
    handleCancel() {
      this.$emit('update:show', false);
    },

    async handleAddAlias(evt) {
      if(evt) {
        evt.preventDefault();
      }
      if(!this.isDataValid) {
        return;
      }

      this.loading = true;
      this.errors = [];

      let result = await this.addMethod({
        portId: this.portId,
        name: this.fields.name.value,
      });

      if(result.error) {
        if(result.error_details.message.includes('already exists')) {
          this.errors.push('This alias already exists');
        } else {
          this.errors.push('Unknown error');
        }
      } else {
        this.$emit('update');
        this.$emit('update:show', false);
      }

      this.loading = false;
    },
  },

  computed: {
    isDataValid() {
      return (
        this.fields.name.value &&
        this.fields.name.value.length > 3
      );
    }
  },

  watch: {
    show: function (value) {
      if(!value) {
        Object.keys(this.fields).forEach(fieldName => {
          this.fields[fieldName].value = null;
        });
      }
    },
  },
}
</script>


<style scoped lang="scss">
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }
</style>
